// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"d8d13be6","422":"6df92514","455":"4e4ea7ff"}[chunkId] + ".chunk.js";
};